function IconArrowRight() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="9" viewBox="0 0 6 9" fill="none">
            <path d="M4.92309 4.4905L1.2144 8.19916C1.03554 8.37803 0.745548 8.37803 0.566702 8.19916L0.134145 7.76661C-0.0444155 7.58805 -0.0447592 7.29865 0.133382 7.11967L3.07258 4.16664L0.133382 1.21362C-0.0447592 1.03464 -0.0444155 0.745245 0.134145 0.566685L0.566702 0.134129C0.745567 -0.0447378 1.03555 -0.0447378 1.2144 0.134129L4.92309 3.84278C5.10193 4.02164 5.10193 4.31163 4.92309 4.4905Z" fill="currentColor" />
        </svg>
    )
}

export default IconArrowRight;